import { FC, useState, useEffect } from "react";
import xml2js from "xml2js";
import { CatagoryWrapper, Title } from "./Catagories.styled";

interface Props {
  catagories: any;
}

const Catagories: FC<Props> = ({ catagories }) => {
  const [result, setResult] = useState<any[]>();
  useEffect(() => {
    let parser = new xml2js.Parser();
    parser.parseString(catagories, function (err: string, result: any) {
      if (result) {
        setResult(result.BrowseList.Facet);
      }
    });
  }, []);

  return (
    <>
      <Title>Job Category</Title>
      <CatagoryWrapper>
        {result?.map((item, i) => {
          return (
            <a
              key={i}
              target="_blank"
              rel="noopener noreferrer"
              href={item.DetailsUrl[0]}
            >
              <div className="catagory_item">{item.FacetName[0]}</div>
            </a>
          );
        })}
      </CatagoryWrapper>
    </>
  );
};

export default Catagories;
